/*
 * Selleasy cross-sell variant sync (defect F15).
 *
 * Problem: the Selleasy "Pour compléter votre achat" widget (lb-upsell-widget) reads the
 * selected variant from the page URL only at load. Dawn rewrites ?variant= through
 * history.replaceState with no reload, so the widget stays on whichever variant the page
 * opened with — customers add the wrong size, or a duplicate support.
 *
 * Fix: Selleasy exposes a public utility, window.lbSelleasyUtils.matchVariant(). Called with
 * no arguments it re-reads the variant from location.href and re-applies variant matching to
 * every lb-upsell-widget on the page. We call it whenever the PDP variant actually changes.
 *
 * Why subscribe() and not a document 'change' listener plus a timeout:
 * product-info.js calls updateURL() (history.replaceState) BEFORE it publishes
 * PUB_SUB_EVENTS.variantChange, in the same synchronous call stack. Subscribing therefore
 * guarantees ?variant= is already current when matchVariant() reads location.href — there is
 * no delay to tune and no race to lose. It is also the only publish site for that event.
 *
 * LOAD-BEARING — do not "simplify away" the URL comparison below. It carries two guards:
 *   1. It keeps us off a cross-sell's OWN picker. Selleasy's widget pickers are app-block UI:
 *      they never publish Dawn's variantChange and never touch the PDP ?variant=, so gating on
 *      a real URL change means a customer changing a cross-sell's variant is never clobbered.
 *   2. It absorbs product-info instances rendered with data-update-url="false" (quick-add,
 *      featured product). Those publish variantChange without changing the URL, and re-matching
 *      on them would reset the widget for no reason.
 *
 * Fail-safe: optional chaining makes this a silent no-op when Selleasy is absent (app
 * uninstalled, script blocked, campaign not configured). It is an additive listener — it
 * patches nothing, removes nothing, and touches only lb-upsell-widget subtrees via the app's
 * own public function.
 *
 * Note: matchVariant() itself no-ops unless that campaign's "Automatically match offer product
 * variants" setting is ON in the Selleasy admin. That is per-campaign configuration, not a
 * theme concern.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function currentVariantParam() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  var lastVariantParam = currentVariantParam();

  subscribe(PUB_SUB_EVENTS.variantChange, function () {
    var variantParam = currentVariantParam();
    if (variantParam === lastVariantParam) return;
    lastVariantParam = variantParam;
    window.lbSelleasyUtils?.matchVariant?.();
  });
})();
